/** Additional Sentry 11 diagnostics enabled by Ricardo on 2026-09-25. */
export function additionalSentryDataCollection() {
  return {
    userInfo: true,
    cookies: true,
    httpHeaders: true,
    httpBodies: ['incomingRequest', 'outgoingRequest', 'incomingResponse', 'outgoingResponse'] as (
      | 'incomingRequest'
      | 'outgoingRequest'
      | 'incomingResponse'
      | 'outgoingResponse'
    )[],
    urlQueryParams: true,
    genAI: { inputs: true, outputs: true },
    databaseQueryData: true,
    queues: true,
    graphQL: { document: true, variables: true },
  };
}
